import { render } from "./WingoCountdown.vue?vue&type=template&id=45d39b9c&scoped=true"
import script from "./WingoCountdown.vue?vue&type=script&lang=js"
export * from "./WingoCountdown.vue?vue&type=script&lang=js"

import "./WingoCountdown.vue?vue&type=style&index=0&id=45d39b9c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d39b9c"]])

export default __exports__